import { render, staticRenderFns } from "./payPz.vue?vue&type=template&id=7a771ebe&scoped=true"
import script from "./payPz.vue?vue&type=script&lang=js"
export * from "./payPz.vue?vue&type=script&lang=js"
import style0 from "./payPz.vue?vue&type=style&index=0&id=7a771ebe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a771ebe",
  null
  
)

export default component.exports